import React, { useState, useEffect } from "react";
import {
  Page,
  Icon,
  Link,
  Popup,
  Button,
  Swiper as SwiperComponent,
  SwiperSlide,
  f7,
} from "framework7-react";
import axios from "axios";
import { API_BASE_URL, API_AUTH, IMG_URL } from "./../globals";

const eatBidsLogo = require("./../images/logo/eatbids-logo.png");
const TabSearch = () => {
  const [restdata, setRestDetails] = useState([]);
  const [serviceType, setServiceType] = useState([]);
  const [cuisineType, setCuisineType] = useState([]);
  const [cuisineId, setCuisineId] = useState([]);
  const [serviceId, setServiceId] = useState(0);

  useEffect(() => {
    axios
      .get(API_BASE_URL + "restaurantdetails", {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
      })
      .then((response) => setRestDetails(response.data))
      .catch((error) => console.log(error));

    axios
      .get(API_BASE_URL + "servicetype", {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
      })
      .then((response) => setServiceType(response.data))
      .catch((error) => console.log(error));

    axios
      .get(API_BASE_URL + "cuisintype", {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
      })
      .then((response) => setCuisineType(response.data))
      .catch((error) => console.log(error));
  }, []);

  const searchRestaurant = () => {
    console.log(cuisineId);
    console.log(serviceId);
    axios
      .get(API_BASE_URL + "restaurantdetails", {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
        params: {
          cuisine: cuisineId,
          service: serviceId,
        },
      })
      .then((response) => setRestDetails(response.data))
      .catch((error) => {
        console.log(error);
        setRestDetails([]);
      });
    f7.popup.close(".demo-popup");
  };
  const clearSearch = () => {
    setCuisineId([]);
    setServiceId(0);
    const radioButtons = document.querySelectorAll('input[type="radio"]');
    radioButtons.forEach((radioButton) => {
      radioButton.checked = false;
    });
  };

  const openSearchPage = () => {
    f7.views.main.router.navigate({ name: "searchRestaurant" });
  };
  const handleLinkClick = (id) => {
    console.log(id);
    f7.views.main.router.navigate({
      name: "cuisine",
      params: {
        cid: id,
      },
    });
  };

  const handleCheckboxChange = (e) => {
    const itemId = e.target.value;
    const isItemChecked = cuisineId.includes(itemId);
    if (isItemChecked) {
      setCuisineId(cuisineId.filter((id) => id !== itemId));
      const radio = (document.getElementById(
        `cuisine-${itemId}`
      ).checked = false);
      console.log(radio);
    } else {
      setCuisineId([...cuisineId, itemId]);
      document.getElementById(`cuisine-${itemId}`).checked = true;
    }
    console.log(cuisineId);
    console.log(cuisineId.includes(itemId));
  };
  const divStyle = {
    backgroundImage: `url("${eatBidsLogo}")`, // Replace with the actual path to your image
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover", // Adjust as needed (e.g., 'contain', '100% 100%', etc.)
    backgroundPosition: "top left", // Positions the image at the top-left corner
    marginTop: "-30px",
    marginBottom: "-20px",
    marginLeft: "10px",
    width: "106px", // Set the width and height to fill the viewport
    height: "40px",
  };

  return (
    <Page className="bg-white">
      <div className="container container-table">
        <div className="row vertical-center-row col-md-12 col-md-offset-12">
          <div className="">
            <header className="section-t-space">
              <div className="container-lg custom-container p-0">
                <div className="header-panel pt-3">
                  <h2>Browse</h2>
                </div>
                <div
                  className="custom-logo d-none d-sm-block d-md-block d-lg-block"
                  style={divStyle}
                />
              </div>
            </header>
            {/* <div className="section full mt-2">
              <div className="appHeader">
                <div className='pageTitle'>
                  <h2>Browse</h2>
                </div>
              </div>        
            </div> */}
            <section className="search-section section-t-space mt-5">
              <div className="custom-container p-0">
                <form className="auth-form search-head">
                  <div className="form-group">
                    <div className="form-input">
                      <input
                        type="text"
                        className="form-control search"
                        onClick={openSearchPage}
                        id="inputusername"
                        placeholder="Restaurant, item & more"
                      />
                      <Icon
                        ios="material:search"
                        aurora="material:search"
                        md="material:search"
                        size={22}
                      ></Icon>
                    </div>
                    <Button
                      fill
                      className="btn filter-button mt-0"
                      popupOpen=".demo-popup"
                    >
                      <Icon
                        ios="material:tune"
                        aurora="material:tune"
                        md="material:tune"
                      ></Icon>
                    </Button>
                  </div>
                </form>
              </div>
            </section>

            <section className="section-t-space">
              <div className="custom-container p-0">
                <div className="title">
                  <h3 className="mt-0">Cuisine Categories</h3>
                  {/* <a href="/111/">See All</a> */}
                </div>
                <div className="swiper categories">
                  <SwiperComponent
                    // pagination={{ clickable: true }}
                    spaceBetween={20}
                    slidesPerView={4}
                  >
                    {cuisineType.map((element) => (
                      <SwiperSlide>
                        <div className="swiper-slide">
                          <a
                            className="food-categories "
                            onClick={(e) => {
                              handleLinkClick(element.id);
                            }}
                          >
                            {/* <img className="img-fluid categories-img" src="https://cdn-icons-png.flaticon.com/128/2872/2872222.png" alt="Cuisine" /> */}
                            <img
                              className="img-fluid categories-img"
                              src={`${element.img}`}
                              alt={`${element.cuisine_name}`}
                            />
                          </a>
                          <h6>{element.cuisine_name}</h6>
                        </div>
                      </SwiperSlide>
                    ))}
                  </SwiperComponent>
                </div>
              </div>
            </section>
            <section className="section-t-space mt-2 mb-3">
              <div className="custom-container p-0">
                <div className="title">
                  <h3 className="mt-0">Order Directly from Restaurants</h3>
                </div>
                <div className="container p-0">
                  <div className="row gy-3 ">
                    {restdata.map((restdetail) => (
                      <div className="bid-web-view-div">
                        <a href={`/restaurantdetail/${restdetail.rest_id}/`}>
                          <div className="vertical-product-box restaurant-product-box">
                            <div className="vertical-box-img">
                              <a
                                href={`/restaurantdetail/${restdetail.rest_id}/`}
                              >
                                {restdetail.rest_img !== null ? (
                                  <img
                                    className="img-fluid img"
                                    src={`${IMG_URL}${restdetail.rest_img}`}
                                    alt={restdetail.rest_name}
                                    style={{ height: "120px", width: "100%" }}
                                  />
                                ) : (
                                  <img
                                    className="img-fluid img"
                                    src={require("./../images/no-image.png")}
                                    alt={restdetail.rest_name}
                                    style={{ height: "120px", width: "100%" }}
                                  />
                                )}
                              </a>
                              <div className="like-icon">
                                {/* <i className="ri-heart-3-line outline-icon" /> */}

                                <i className="ri-heart-3-fill fill-icon" />
                                <div className="effect-group">
                                  <span className="effect" />
                                  <span className="effect" />
                                  <span className="effect" />
                                  <span className="effect" />
                                  <span className="effect" />
                                </div>
                              </div>
                            </div>
                            <div className="vertical-box-details">
                              <div className="vertical-box-head">
                                <div className="restaurant">
                                  <a
                                    href={`/restaurantdetail/${restdetail.rest_id}/`}
                                  >
                                    <h5>{restdetail.rest_name}</h5>
                                  </a>
                                </div>
                                <h6 className="food-items text-capitalize">
                                  {restdetail.cuisine_name}

                                  {/* {restdetail.menu_details.map(menu => (
                                  menu.menu_item_name + ', '
                                ))} */}
                                </h6>
                              </div>
                              <div className="location-distance">
                                <div className="location1">
                                  <p className="place text-secondary mt-1">
                                    <Icon
                                      ios="material:location_on"
                                      aurora="material:location_on"
                                      md="material:location_on"
                                      size={16}
                                      className="text-success"
                                    ></Icon>{" "}
                                    {restdetail.add_lin_1}{" "}
                                    {restdetail.add_lin_2} {restdetail.city}{" "}
                                    {restdetail.state} {restdetail.zip_code}
                                  </p>
                                  {/* <h6 className="pt-2 pb-2 text-dark">Start from <span className="text-danger">$95</span> for one tray</h6> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </a>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </section>
            <Popup className="demo-popup custom-web">
              <Page>
                <div className="search-filter modal-dialog modal-fullscreen custom-web">
                  <div className="modal-content">
                    <div className="modal-title">
                      <h3 className="fw-bold">Filter</h3>
                      <Link className="btn-close" popupClose />
                    </div>
                    <section className="section-b-space pt-0">
                      <div className="custom-container">
                        <section className="pt-0">
                          <div className="order-options">
                            <h3 className="mt-3 mb-3 dark-text fw-bold">
                              Service Type
                            </h3>
                            <div className="order-type">
                              <div class="grid-container">
                                {serviceType.map((item, index) => (
                                  <div className="auth-form search-form">
                                    <div className="form-check">
                                      <label
                                        className="form-check-label"
                                        htmlFor={`checkbox-${item.id}`}
                                      >
                                        {item.service_name}
                                      </label>
                                      <input
                                        className="form-check-input"
                                        value={item.id}
                                        onClick={(e) =>
                                          setServiceId(e.target.value)
                                        }
                                        checked={serviceId == item.id}
                                        type="radio"
                                        name={`checkbox-${item.id}`}
                                        id={`checkbox-${item.id}`}
                                      />
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        </section>
                        <section className="pt-0 section-lg-b-space">
                          <div className="order-options">
                            <h3 className="mb-3 dark-text fw-bold">
                              Cuisine type
                            </h3>
                            <div className="order-type">
                              <div class="grid-container">
                                {cuisineType.map((item, index) => (
                                  <div className="auth-form search-form">
                                    <div className="form-check">
                                      <label
                                        className="form-check-label"
                                        htmlFor={`cuisine-${item.id}`}
                                      >
                                        {item.cuisine_name}
                                      </label>
                                      <input
                                        className="form-check-input"
                                        value={item.id}
                                        type="radio"
                                        onClick={handleCheckboxChange}
                                        name={`cuisine-${item.id}`}
                                        id={`cuisine-${item.id}`}
                                      />
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        </section>
                      </div>
                    </section>
                    <div className="footer-modal d-flex">
                      <a
                        type="button"
                        onClick={clearSearch}
                        className="btn btn-link btn-inline mt-0 w-50"
                      >
                        Clear Filter
                      </a>
                      <a
                        type="button"
                        onClick={searchRestaurant}
                        className="theme-btn btn btn-inline mt-0 w-50"
                      >
                        Apply
                      </a>
                    </div>
                  </div>
                </div>
              </Page>
            </Popup>
          </div>
        </div>
      </div>
    </Page>
  );
};

export default TabSearch;
